/**
 * MRI 브릿지 로더(Vue) — 실제 브릿지는 MRI(mri.naezipscan.com/bridge.js)가 서빙한다. 이 파일은 바뀔 일이 거의 없다.
 * 켜지는 조건: VUE_APP_MRI_BRIDGE === "1"(Vercel Preview env에만) && iframe 안. 프로덕션은 no-op.
 * data-mri 태그·public/mri-screens.json은 각 화면 작업(피처 브랜치)에서 관리한다.
 */
const ENABLED = process.env.VUE_APP_MRI_BRIDGE === "1";
const BRIDGE_URL = process.env.VUE_APP_MRI_BRIDGE_URL || "https://mri.naezipscan.com/bridge.js";

function inFrame() {
  return typeof window !== "undefined" && window.parent !== window;
}

/** 라우터 가드가 이관 라우트로 풀 리로드하기 직전에 부른다 — MRI가 web-core 프리뷰로 iframe을 바꾼다. */
export function mriHandoff(route) {
  if (!ENABLED || !inFrame()) return;
  if (window.MRI_BRIDGE) window.MRI_BRIDGE.handoff("web-core", route);
}

export function installMriBridge(router) {
  if (!ENABLED || !inFrame()) return;
  const s = document.createElement("script");
  s.src = BRIDGE_URL;
  s.async = true;
  s.onload = () => {
    if (!window.MRI_BRIDGE) return;
    window.MRI_BRIDGE.init({
      navigate: route => router.push(route).catch(() => {}),
      apiHost: process.env.VUE_APP_HOST || "",
      sessionKey: "naezip_to_ac_se",
      basePath: "",
    });
  };
  (document.head || document.documentElement).appendChild(s);
}
